import React, { useEffect } from 'react'

import { isAndroid, isMobileSafari } from 'react-device-detect'

import Icon from '@components/icon/icon.component'

import useStyles from './push-reg.style'
import { PUSH_REG_TEXT } from '../../assets/i18n/strings'
import i18n from 'i18n-js'

const PushReg = props => {
  const classes = useStyles(props)

  useEffect(() => {
    if (isMobileSafari) {
      window.location.href = 'itms://itunes.apple.com/us/app/omnilert/id1472552124?mt=8'
    }

    if (isAndroid) {
      window.location.href = 'http://play.google.com/store/apps/details?id=com.omnilert.omnilert'
    }
  }, [])

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes.messageBody}>
          <div className={classes.messageDescription}>
            <span className={classes.text}>{i18n.t(PUSH_REG_TEXT)}</span>
          </div>
        </div>
      </div>
      <div className={classes.logoContainer}>
        <Icon type='logo-powered' />
      </div>
    </div>
  )
}

export default PushReg
